export const LocalStorageKeys = {
  personId: "farther:authn:personId",
  personType: "farther:authn:personType",
  token: "farther:authn:token",
  email: "farther:authn:email",
  lastLoginType: "farther:authn:lastLoginType",
  redirectTo: "farther:authn:redirectTo",
  sessionToken: "farther:authn:sessionToken",
} as const;
